import { parseJwt } from '@/utils/jwt';
import { subscribe } from '@/utils/socket';
import { postToApp } from '@/utils/appBridge';
import { isFeatureFlagEnabled } from '@/plugins/growthbook/growthbook';

// Superintresse is the consumables variant's. init and checkPaymentRedirect
// run at app start for everyone, so they check the flag themselves: the
// control group gets neither the listener nor the reopened sheet. They run
// after initGrowthbook but before app/ready, which is why they read
// GrowthBook directly instead of app/isTestEnabled.
const consumablesEnabled = () => isFeatureFlagEnabled('consumables');

// Keeps the Superintresse balance (menu/superLikesRemaining) current: the
// backend emits new-payment on the websocket for every booked payment —
// Adyen on the web, RevenueCat in the app — so a superlikes payment
// refreshes the balance in every open page (the browser, the app's web
// views behind its native panel, other tabs) the moment the credits exist.
function init(context) {
  if (!consumablesEnabled()) {
    return;
  }
  subscribe('new-payment', message => {
    if (!message || !message.product) {
      return;
    }
    if (message.product.category !== 'superlikes') {
      return;
    }
    context.dispatch(
      'menu/fetchNotifications',
      context.rootGetters['myPropositions/primaryPropositionId'],
      { root: true }
    );
  });
}

// "Buy more Superintresse" — every out-of-quota path ends here. In the
// browser it opens the web's purchase sheet; inside the app's WebView it
// hands over to the app, which opens its own payment panel (native
// RevenueCat on iOS with in-app purchase, otherwise the web's
// /buy-super-interest page in the app's modal), the same split as boost.
function openPurchase(context) {
  const handedOver = postToApp({
    type: 'OPEN_SUPER_INTEREST_PURCHASE',
    propositionId: context.rootGetters['myPropositions/primaryPropositionId']
  });
  if (handedOver) {
    return;
  }
  context.dispatch('ui/setGlobalModal', 'SuperInterestPurchase', {
    root: true
  });
}

// Back from a payment redirect (3-D Secure, Swish, …) with ?q=<jwt>: Adyen
// only completes the payment once its form is mounted again, so reopen the
// Superintresse sheet for a 'superlikes' product. The boost module does the
// same for 'extrasynlighet'.
function checkPaymentRedirect(context) {
  if (!consumablesEnabled()) {
    return;
  }
  const isReactNative = window.originalPostMessage;
  if (isReactNative) {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const q = urlParams.get('q');

  if (!q) {
    return;
  }

  let productType;
  try {
    ({ productType } = parseJwt(q));
  } catch (error) {
    return;
  }

  if (productType === 'superlikes') {
    context.dispatch('ui/setGlobalModal', 'SuperInterestPurchase', {
      root: true
    });
  }
}

export default { init, openPurchase, checkPaymentRedirect };
